import $Cookies from 'js-cookie';
// 初始化code
export const initAgentCode = (that, objName = 'ruleForm', keyName = "agentCode") => {
  let agentCode = that.$route.query.agt || $Cookies.get('agt')
  let agentId = that.$route.query.agentCode || window.sessionStorage.getItem('registerAgentId')
  if (!agentCode) {
    if (that.$store.state.registerAgentCode) that.$set(that[objName], keyName, that.$store.state.registerAgentCode)
  } else {
    that.$set(that[objName], keyName, agentCode)
    that.$store.commit('setRegisterAgentCode', agentCode)
  }

  if (!agentId) {
    if (that.$store.state.registerAgentId) that.$set(that[objName], 'agentID', that.$store.state.registerAgentId)
  } else {
    that.$set(that[objName], 'agentID', agentId)
    that.$store.commit('setRegisterAgentId', agentId)
  }
}

export const setAgentCode = (store,number) => { // 存入代理注册code并修改网页路径
  const hrefStr = window.location.href
  if (hrefStr.indexOf('?agt=') !== -1 || hrefStr.indexOf('&agt=') !== -1) {
    const strCode = hrefStr.split('?')[1]
    let agentCode = ''
    const arrcCodes = strCode.split('&');
    for(let i = 0; i < arrcCodes.length; i++) {
      if (arrcCodes[i].indexOf('agt=') !== -1) {
        agentCode = arrcCodes[i].split('agt=')[1]
        break;
      }
    }
    store.commit('setRegisterAgentCode', agentCode)
    // if(number === 800 ) window.location.href = window.location.origin + '/signup'
    if(hrefStr.indexOf('/newregister') !== -1){
      if(number === 800 ) window.location.href = window.location.protocol + '//' + window.location.host + '/newregister';
    }else{
      if(number === 800 ) window.location.href = window.location.protocol + '//' + window.location.host + '/signup';
    }
    if (hrefStr.indexOf('/signup') === -1) { // 不是邀请链接的时候
      const str = '?agt=' + agentCode
      if (!!(window.history && history.pushState)) {
        history.replaceState(null, null, (window.location.href.replace(str, '') + str))
      } else {
        window.location.href = window.location.href.replace(str, '') + str
      }
    }
  }
  if (hrefStr.indexOf('?agentCode=') !== -1 || hrefStr.indexOf('&agentCode=') !== -1) {  // 个人邀请
    const strCodeId = hrefStr.split('?')[1]
    let agentID = ''
    const arrcCodeId = strCodeId.split('&');
    for(let i = 0; i < arrcCodeId.length; i++) {
      if (arrcCodeId[i].indexOf('agentCode=') !== -1) {
        agentID = arrcCodeId[i].split('agentCode=')[1]
        break;
      }
    }
    store.commit('setRegisterAgentId', agentID)
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/initRegisterAgentCode.js